/**
 * Store to hold all SEMP Connection details for the configured Solace brokers
 */
import { writable } from 'svelte/store';
/**
 * Class to hold a SEMP Connection's details
 */
export class SempConnection {
    constructor(id, isConnected, label = '', sempUrl = '', vpnName = '', sempUser = '', sempPassword = '', sempVer = 0.0) {
        this.id = id;
        this.label = label;
        this.isConnected = isConnected;
        this.sempUrl = sempUrl;
        this.vpnName = vpnName;
        this.sempUser = sempUser;
        this.sempPassword = sempPassword;
        this.sempVer = sempVer;
    }
    buildVpnMonitorUrl(attrs) {
        return `${this.sempUrl}/SEMP/v2/monitor/msgVpns/${this.vpnName}?select=${attrs.join(',')}`;
    }
    buildVpnClientUrl() {
        return `${this.sempUrl}/SEMP/v2/monitor/msgVpns/${this.vpnName}/clients?select=clientName,clientUsername,clientAddress`;
    }
    buildVpnClientMonitorUrl(client, attrs) {
        return `${this.sempUrl}/SEMP/v2/monitor/msgVpns/${this.vpnName}/clients/${encodeURI(client).replace(/#/g, "%23").replace(/\//g, "%2F")}?select=clientName,clientUsername,clientAddress,${attrs.join(',')}`;
    }
    buildAuthHeader() {
        return 'Basic ' + btoa(this.sempUser + ':' + this.sempPassword);
    }
}
//Utility function for creating a store of SEMPConnections
function createBrokerStore(initialValue = []) {
    const { subscribe, update } = writable(initialValue);
    return {
        subscribe,
        addOrUpdateBroker(sempConnection) {
            update((brokers) => [...brokers, sempConnection]);
        },
        removeBroker(id) {
            update(brokers => brokers.filter(broker => broker.id !== id));
        },
        loadConfig(config) {
            update(brokers => {
                brokers = config;
                return brokers;
            });
        }
    };
}
// export const brokerStore = createBrokerStore([new SempConnection(1,true,'Node1','http://localhost:8080','default','admin','admin')]);
export const brokerStore = createBrokerStore();
